import Cookies from 'universal-cookie';
const cookies = new Cookies();

class Auth {

    static key = 'access_token';

    static getToken = () => {
        let access_token = cookies.get('access_token');
        return access_token;
    };

    static setToken = (token) => {
        let access_token = cookies.get('access_token') || {};
        cookies.set('access_token', access_token, { path: '/' });
    };

    static clear = () => {
        localStorage.clear();
        cookies.remove('access_token', {path: '/'})
    };
}

export {Auth};